/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Share_Emailcolumn2Inputs */

const en_coinvestments_share_emailcolumn2 = /** @type {(inputs: Coinvestments_Share_Emailcolumn2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email`)
};

/**
* | output |
* | --- |
* | "Email" |
*
* @param {Coinvestments_Share_Emailcolumn2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_share_emailcolumn2 = /** @type {((inputs?: Coinvestments_Share_Emailcolumn2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Share_Emailcolumn2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_share_emailcolumn2(inputs)
});
export { coinvestments_share_emailcolumn2 as "coInvestments_share_emailColumn" }